export default [
  {
    feedback: {
      content: `Перед тем, как прийти на практику, у меня уже были положительные отзывы, поэтому я знал,
                что нахожусь на правильном пути. Что из себя представляет практика в компании?
                Это три по настоящему крутых месяца, где ты растёшь как специалист, решая классные задачи.
                На протяжении всей практики тебя сопровождает команда разработчиков: новый материал в формате лекций,
                практические задачи на закрепление материала и регулярное общение с уже матёрыми ребятами.
                При возникновении вопросов можно было обратиться к команде и в 100% случаев получить ответ.
                Таким образом, можно неплохо прокачать не только хард скиллы, но и софты.<br>
                Ещё один крутой момент - это современный стек технологий.
                Команда регулярно изучает то, что актуально и полезно в наши дни,
                поэтому материалы лекций по настоящему полезны будущему специалисту.<br>
                Ну, и как приятный бонус - это кухня с вкусняшками. Всегда можно найти что-то вкусное,
                выпить чай или кофе, а также каждый четверг тебя будет ждать пицца.`,
      author: 'Сергей',
    },
    img: {
      x1: '/images/photos/interns/Artboard-6.jpg',
      webp: '/images/photos/interns/Artboard-6.webp',
      alt: 'Сергей',
    },
  },
  {
    feedback: {
      content: `Практика в компании стала одним из самых знаменательных событий в жизни, как в профессиональном,
                  так и в личном плане.<br>
                  Весь процесс проходил в комфортном, уютном офисе, где у каждого есть своё рабочее место,
                  оборудованное всем необходимым. Есть возможность собираться компанией на кухне для того,
                  чтобы просто поболтать за чашкой чая с печеньками, а также поесть пиццу по четвергам.
                  Можно сказать, что даже само нахождение в офисе способствует росту как личности,
                  ведь вокруг столько разных интересных людей, увлеченных общим делом, что стоять на месте просто невозможно. <br>
                  Сама программа обучения состоит из изучения современных технологий и подходов к разработке.
                  Наставники всегда готовы помочь в трудной ситуации, всё подробно и понятно объяснить.
                  Все полученные знания закрепляются на практике выполнением различных заданий,
                  а в конце ждёт финальный проект, который пусть и не полностью,
                  но определенно позволит получить представление о разработке реального проекта.`,
      author: 'Егор',
    },
    img: {
      x1: '/images/photos/interns/Artboard-7.jpg',
      webp: '/images/photos/interns/Artboard-7.webp',
      alt: 'Егор',
    },
  },
  {
    feedback: {
      content: `Попал на практику с третей попытки и очень рад, что не сдался после первых двух.
                  Пусть практика проходила два месяца, она пролетела незаметно, настолько проекты были интересными и захватывающими.
                  В офисе работать одно удовольствие, очень комфортная и легкая атмосфера, индивидуальные рабочие места,
                  дружный и внимательный коллектив, ну и конечно же пицца по четвергам.
                  Программа практики была гармонично построена, что позволило получить большое количества знаний и закрепить их,
                  работая над проектами. Один момент мне особо понравился: на практике мы работали в парах над разными приложениями,
                  а через месяц поменялись проектами, это дало новый и очень полезный опыт работы с чужим кодом и взаимодействия между командами. <br>
                  Практика в "Очень Интересно" - это несомненно лучшее, что можно пройти начинающему разработчику. Всем советую!`,
      author: 'Руслан',
    },
    img: {
      x1: '/images/photos/interns/Artboard-3.jpg',
      webp: '/images/photos/interns/Artboard-3.webp',
      alt: 'Руслан',
    },
  },
  {
    feedback: {
      content: `Зимняя практика запомнилась мне многим. Я оказался среди умнейших разносторонних ребят,
                  у которых многому можно научится. Я углубился в платформу .NET и стал разрабатывать то,
                  что до этого казалось слишком сложным и непонятным. Для меня было немного сложно совмещать
                  практику с учебой в начале, но я научился и этому. Такие soft-скилы, как time-managment и
                  коммуникабельность - очень важны для программиста, и их я тоже приобрел во время практики. <br>
                  Сейчас, работая здесь, я могу сказать, что прекрасно адаптировался в компании за время практики,
                  и искренне рад, где, с кем и над чем я работаю. Хочу выразить благодарность каждому,
                  кто был причастен к этому интересному пути. Этот опыт очень ценен и я желаю каждому,
                  кто интересуется IT - получить его как можно раньше.`,
      author: 'Андрей',
    },
    img: {
      x1: '/images/photos/interns/Artboard-4.jpg',
      webp: '/images/photos/interns/Artboard-4.webp',
      alt: 'Андрей',
    },
  },
  {
    feedback: {
      content: `Дружный и уютный коллектив, профессиональные наставники и интересные задачи,
                  над решением которых порой придется подумать - это и многое другое ожидало меня,
                  когда я пришел на практику в "Очень Интересно". Здесь можно поднять свои практические
                  навыки благодаря задачам, приближенным к реальным проектам, и периодическому код ревью от старших коллег,
                  которые укажут на ошибки и помогут стать лучше. Помимо этого, очень интересно было послушать
                  лекции с основами Unity, и не только. За два месяца я узнал огромное количество актуальной и полезной
                  информации о разработке на Unity, а также значительно повысил практические навыки,
                  за что не могу не сказать спасибо всем организаторам практики. Ну и напоследок - комфортный офис и
                  читы в виде пиццы по четвергам подкупят любого.`,
      author: 'Иван',
    },
    img: {
      x1: '/images/photos/interns/Artboard-2.jpg',
      webp: '/images/photos/interns/Artboard-2.webp',
      alt: 'Иван',
    },
  },
  {
    feedback: {
      content: `В ходе практики мы выполняли ряд разнообразных задач. Какие-то были легкими, какие-то посложнее.
                  Но все их мы делали с применением стандартов и практик компании, о которых нам рассказывали на лекциях.
                  Все они также проходили code review от опытных разработчиков компании, что несомненно повысило
                  качество нашего кода. А под конец практики и вовсе удалось поработать в команде над реальным проектом,
                  над которым я продолжаю работать и сейчас.<br>
                  Отдельно стоит отметить атмосферу в компании – все здесь доброжелательны, общительны и готовы
                  помочь начинающим разработчикам. Несмотря на 4-х часовой рабочий день зимней практики,
                  я часто ловил себя на том, что проводил в офисе гораздо больше времени за счет общения с коллегами
                  по практике и сотрудниками компании.`,
      author: 'Дмитрий',
    },
    img: {
      x1: '/images/photos/interns/Artboard-5.jpg',
      webp: '/images/photos/interns/Artboard-5.webp',
      alt: 'Дмитрий',
    },
  },
];



// WEBPACK FOOTER //
// ./src/data/summerCampFeedbacks.js